import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, withStyles } from 'material-ui';
import Slide from 'material-ui/transitions/Slide';
import PassengersCounterDialogStyles from './PassengersCounterDialogStyles';
import PassengersCountersTabsWrapper from '../../common/passengersCounter/PassengersCounterTabsWrapper';

function Transition (props) {
  return <Slide direction='up' {...props} />;
}

const PassengersCounterDialog = ({
  selectedRoute,
  selectedTrip,
  flights,
  changePassengerNumber,
  open,
  handleClose,
  handleTabChange,
  selectedTab,
  classes,
}) => (
  <Dialog fullScreen open={open} onClose={handleClose} transition={Transition} classes={classes}>
    <PassengersCountersTabsWrapper
      selectedRoute={selectedRoute}
      selectedTrip={selectedTrip}
      flights={flights}
      selectedTab={selectedTab}
      handleTabChange={handleTabChange}
      changePassengerNumber={changePassengerNumber}
      handleClose={handleClose}
    />
  </Dialog>
);

PassengersCounterDialog.propTypes = {
  selectedRoute: PropTypes.object,
  selectedTrip: PropTypes.object,
  flights: PropTypes.arrayOf(PropTypes.object),
  changePassengerNumber: PropTypes.func,
  handleClose: PropTypes.func,
  open: PropTypes.bool,
  selectedTab: PropTypes.number,
  handleTabChange: PropTypes.func,
  classes: PropTypes.object,
};

export default withStyles(PassengersCounterDialogStyles)(PassengersCounterDialog);



// WEBPACK FOOTER //
// ./src/containers/flights/mobile/passengersCounter/PassengersCounterDialog.js